export default __webpack_public_path__ + "static/media/asmt-step6.4b56cf0a.gif";